import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { isTruthyRoleFlag } from './utils/bulk-upload-access';
import { hasPreReviewAccess } from './utils/pre-review-role-access';

function loadRoleFromSession(): any {
  try {
    const roleDetailRaw = localStorage.getItem('role_detail');
    if (roleDetailRaw) return JSON.parse(roleDetailRaw);
  } catch {
    /* ignore */
  }
  try {
    const currentUserRaw = localStorage.getItem('current_user');
    if (currentUserRaw) {
      const parsed = JSON.parse(currentUserRaw);
      if (parsed?.role && typeof parsed.role === 'object') return parsed.role;
    }
  } catch {
    /* ignore */
  }
  return null;
}

export const preBulkApprovalGuard: CanActivateFn = () => {
  const router = inject(Router);
  const role = loadRoleFromSession();
  const flag = role?.is_pre_bulk_approval_history_visible;
  const allowed = flag != null ? isTruthyRoleFlag(flag) : hasPreReviewAccess(role);
  if (allowed) return true;
  return router.createUrlTree(['/products']);
};
